import HomeWorkOutlinedIcon from "@mui/icons-material/HomeWorkOutlined";
import ArchitectureOutlinedIcon from "@mui/icons-material/ArchitectureOutlined";
import ChairOutlinedIcon from "@mui/icons-material/ChairOutlined";
import NaturePeopleOutlinedIcon from "@mui/icons-material/NaturePeopleOutlined";
import ViewInArOutlinedIcon from "@mui/icons-material/ViewInArOutlined";
import LocationCityOutlinedIcon from "@mui/icons-material/LocationCityOutlined";
import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";

import architecture from "../assets/images/b1_architecture.png";
import interior from "../assets/images/interior.jpg";
import civilAndConstruction from "../assets/images/a_-Civil-Construction-Ed2Go-blog.png";
import landscape from "../assets/images/b_architecture.png";
import visualization from "../assets/images/e_3d_visualization.png";
import landDevelopers from "../assets/images/f_land_development.webp";
import estimation from "../assets/images/g_estimation.jpg";
import projectManagement from "../assets/images/h_projmgmnt.jpg";

export interface ServiceFeature {
  heading: string;
  description: string;
}

export interface ServiceItem {
  slug: string;
  title: string;
  banner: string;
  overview: string;
  features: ServiceFeature[];
}

export interface ServiceCardItem {
  id: string;
  title: string;
  icon: React.ElementType;
  description: string;
  slug: string;
}

export const servicesData: ServiceCardItem[] = [
  {
    id: "civil-construction",
    title: "Civil & Construction",
    icon: HomeWorkOutlinedIcon,
    description:
      "End-to-end civil and construction services with a focus on quality, durability, and timely delivery.",
    slug: "civil-construction",
  },
  {
    id: "architecture",
    title: "Architecture",
    icon: ArchitectureOutlinedIcon,
    description:
      "Thoughtfully designed architectural solutions that balance aesthetics and functionality.",
    slug: "architecture",
  },
  {
    id: "interior-design",
    title: "Interior Design",
    icon: ChairOutlinedIcon,
    description:
      "Elegant and functional interior spaces crafted to reflect your lifestyle.",
    slug: "interior-design",
  },
  {
    id: "landscape",
    title: "Landscape",
    icon: NaturePeopleOutlinedIcon,
    description:
      "Creative landscape designs that enhance outdoor spaces with harmony and beauty.",
    slug: "landscape",
  },
  {
    id: "visualization",
    title: "3D Visualization",
    icon: ViewInArOutlinedIcon,
    description: "High-quality 3D visualizations that bring concepts to life.",
    slug: "3d-visualisation",
  },
  {
    id: "land-development",
    title: "Land Development",
    icon: LocationCityOutlinedIcon,
    description:
      "Strategic land development solutions ensuring long-term value.",
    slug: "land-developers",
  },
  {
    id: "estimation",
    title: "Estimation",
    icon: CalculateOutlinedIcon,
    description:
      "Accurate project estimations helping you plan with confidence.",
    slug: "estimation",
  },
  {
    id: "project-management",
    title: "Project Management",
    icon: AccountTreeOutlinedIcon,
    description:
      "Seamless project management ensuring quality and timely execution.",
    slug: "project-management",
  },
];

export const services: ServiceItem[] = [
  {
    slug: "architecture",
    title: "Architecture",
    banner: architecture,
    overview:
      "We provide innovative architectural solutions focusing on functionality and aesthetics.",
    features: [
      {
        heading: "Concept Design",
        description: "Creative planning aligned with client vision.",
      },
      {
        heading: "Execution",
        description: "End-to-end execution with quality control.",
      },
    ],
  },
  {
    slug: "interior-design",
    title: "Interior Design",
    banner: interior,
    overview: "Modern interior designs that balance comfort and style.",
    features: [
      {
        heading: "Space Planning",
        description: "Efficient use of space with modern layouts.",
      },
      {
        heading: "Custom Furniture",
        description: "Tailor-made furniture solutions.",
      },
    ],
  },
  {
    slug: "civil-construction",
    title: "Civil & Construction",
    banner: civilAndConstruction,
    overview:
      "We deliver reliable civil and construction services with a focus on structural strength, quality materials, and timely execution across residential, commercial, and institutional projects.",
    features: [
      {
        heading: "Structural Execution",
        description:
          "Strong and durable construction using industry-standard practices and quality materials.",
      },
      {
        heading: "Site Management",
        description:
          "Efficient on-site coordination to ensure safety, timelines, and smooth workflow.",
      },
    ],
  },
  {
    slug: "landscape",
    title: "Landscape",
    banner: landscape,
    overview:
      "We design and develop outdoor spaces that enhance the overall environment, combining aesthetics with functionality for residential and commercial properties.",
    features: [
      {
        heading: "Garden Design",
        description:
          "Thoughtfully planned green spaces tailored to the site and client preferences.",
      },
      {
        heading: "Outdoor Development",
        description:
          "Execution of pathways, lawns, and outdoor elements with attention to detail.",
      },
    ],
  },
  {
    slug: "3d-visualisation",
    title: "3D Visualisation",
    banner: visualization,
    overview:
      "We provide realistic 3D visualizations that help clients clearly understand design concepts before construction begins.",
    features: [
      {
        heading: "Concept Rendering",
        description:
          "High-quality 3D views that bring architectural ideas to life.",
      },
      {
        heading: "Design Clarity",
        description:
          "Helps in making informed decisions by visualizing layouts, materials, and finishes.",
      },
    ],
  },
  {
    slug: "land-developers",
    title: "Land Developers",
    banner: landDevelopers,
    overview:
      "We offer land development services including planning, layout design, and infrastructure preparation for residential and commercial projects.",
    features: [
      {
        heading: "Site Planning",
        description:
          "Strategic layout planning to maximize land utilization and accessibility.",
      },
      {
        heading: "Infrastructure Setup",
        description:
          "Development of roads, drainage, and essential utilities for ready-to-use plots.",
      },
    ],
  },
  {
    slug: "estimation",
    title: "Estimation",
    banner: estimation,
    overview:
      "We provide accurate project cost estimation to help clients plan budgets effectively and avoid unexpected expenses during construction.",
    features: [
      {
        heading: "Cost Planning",
        description:
          "Detailed breakdown of materials, labor, and overall project costs.",
      },
      {
        heading: "Budget Control",
        description:
          "Helps in maintaining financial discipline throughout the project lifecycle.",
      },
    ],
  },
  {
    slug: "project-management",
    title: "Project Management",
    banner: projectManagement,
    overview:
      "We ensure smooth project execution through proper planning, coordination, and monitoring from start to completion.",
    features: [
      {
        heading: "Planning & Scheduling",
        description:
          "Well-structured timelines to ensure projects are completed on time.",
      },
      {
        heading: "Quality & Coordination",
        description:
          "Continuous monitoring to maintain quality standards and manage teams effectively.",
      },
    ],
  },
];
